import { CSSProperties, FC, memo, useMemo } from "react";
import "./avatar.scss";
import { Button } from "@components/button";
import { EditIcon } from "@components/icons";
import { getInitials } from "@utils/user.util";
import AvatarLoader from "./skeleton";

export type AvatarImageSize = "medium" | "large" | "small" | "x-small" | "profile" | "card";

interface AvatarProps {
  title?: string;
  imageUrl?: string;
  size?: AvatarImageSize;
  onEditImage?: () => void;
  loading?: boolean;
  className?: string;
  titleFormatter?: (title?: string) => string;
  backgroundColor?: string;
  fontColor?: string;
}

const AvatarComponent: FC<AvatarProps> = ({
  title,
  imageUrl,
  size = "small",
  onEditImage,
  loading,
  className,
  titleFormatter = getInitials,
  backgroundColor,
  fontColor,
}) => {
  const formattedTitle = useMemo(() => titleFormatter?.(title) || title, [title, titleFormatter]);
  const themeStyle = useMemo(
    () =>
      ({
        ...(backgroundColor ? { backgroundColor } : {}),
        ...(fontColor ? { color: fontColor } : {}),
      }) as CSSProperties,
    [backgroundColor, fontColor],
  );
  const hasThemeStyle = !!backgroundColor || !!fontColor;

  return (
    <>
      {loading ? (
        <AvatarLoader size={size} />
      ) : (
        <div
          className={`user ${size || "small"} ${className ?? ""}`}
          // style={backgroundColor ? { backgroundColor } : undefined}
        >
          {!imageUrl ? (
            <span
              className={`short-name ${formattedTitle}`}
              style={hasThemeStyle ? themeStyle : undefined}
            >
              {formattedTitle}
            </span>
          ) : (
            <img
              src={imageUrl}
              alt={formattedTitle}
              className="short-name"
              loading="eager"
              decoding="async"
            />
          )}
          {onEditImage ? (
            <Button onClick={onEditImage} className={`edit-image ${size}`}>
              <EditIcon color="#ffffff" />
            </Button>
          ) : null}
        </div>
      )}
    </>
  );
};

export const Avatar = memo(AvatarComponent);
